import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { campInfo } from '../data/mock';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-emerald-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Kontakt
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Rádi zodpovíme vaše dotazy a pomůžeme s rezervací
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="space-y-6">
            <Card className="border-2 border-emerald-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-emerald-100 rounded-full p-3">
                    <Phone className="w-6 h-6 text-emerald-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Telefon
                    </h3>
                    <a
                      href="tel:+420721022279"
                      className="block text-emerald-600 hover:text-emerald-700 font-medium transition-colors text-lg"
                    >
                      +420 721 022 279
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-emerald-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-emerald-100 rounded-full p-3">
                    <Mail className="w-6 h-6 text-emerald-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Email
                    </h3>
                    <a
                      href="mailto:campjosef@seznam.cz"
                      className="block text-emerald-600 hover:text-emerald-700 font-medium transition-colors"
                    >
                      campjosef@seznam.cz
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-emerald-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-emerald-100 rounded-full p-3">
                    <MapPin className="w-6 h-6 text-emerald-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Adresa
                    </h3>
                    <p className="text-gray-700">
                      {campInfo.location}
                    </p>
                    <p className="text-sm text-gray-600 mt-2">
                      (Cca 10 km od Hodonína)
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-emerald-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-emerald-100 rounded-full p-3">
                    <Clock className="w-6 h-6 text-emerald-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Otevírací doba
                    </h3>
                    <p className="text-gray-700 font-medium">
                      Služba 24 hodin denně, 7 dní v týdnu
                    </p>
                    <p className="text-sm text-gray-600 mt-2">
                      Vždy jsme vám k dispozici
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <div className="bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">
                Zavolejte nám
              </h3>
              <p className="text-emerald-100 mb-6">
                Jsme připraveni zodpovědět vaše dotazy a pomoci vám s rezervací ubytování.
              </p>
              <a href="tel:+420721022279">
                <Button size="lg" className="w-full bg-white text-emerald-700 hover:bg-emerald-50">
                  <Phone className="w-5 h-5 mr-2" />
                  Zavolat nyní
                </Button>
              </a>
            </div>
          </div>

          <div>
            <Card className="overflow-hidden border-2 border-emerald-100 h-full">
              <CardContent className="p-0">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2644.8!2d17.1045942!3d48.9342953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476c8adc65e1a8b5%3A0x86cef5b00cba9ffd!2sKemp%20Josef%2C%20D%C5%AFl%20Josef%20829%2C%20696%2003%20Dub%C5%88any!5e0!3m2!1scs!2scz!4v1713729800000!5m2!1scs!2scz"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '700px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa - Kemp Josef Dubňany"
                ></iframe>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
